<web-bestellhistorie_picker *ngIf="api_zeitraum" [zeitraum]="api_zeitraum" #bestellhistorie_picker></web-bestellhistorie_picker>
<div id="bestellhistorie-preis" *ngIf="bestellung && preis_anzeige">
  <strong>Gesamtpreis des Zeitraums</strong>
  <span>{{ bestellungGesamtpreis | bestellhistoriePreis}} €</span>
</div>
<speiseplan-glossar [mandant]="mandant"></speiseplan-glossar>
